// Polyfills for Node.js globals required by aws-amplify and dependencies
(window as any).global = window;
import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;
